<template>
  <div v-if="!initializing" class="container-resumen">
    <div class="row contenedor w-100">
      <p class="col-12 text-primary bold h5 text-title pointer" @click="moveToMisReservas()">
        <i class="fa-solid fa-chevron-left me-2"></i>{{ $t('home.form.backButton') }}
      </p>
      <p class="col-12 text-primary">
        {{ $t('subtitulo.seleccionServicios') }}
      </p>

      <div class="col-md-8 col-12 py-3">
        <div class="contenedor-occupancy justify-content-start">
          <CardOccupancy
            :max-size="hasAlojamiento ? grupo.habitacion.numPlazas : -1"
            :occupants-info="occupants"
            :plazas-libres-repercutidas="hasAlojamiento ? grupo.habitacion.plazasLibresRepercutidas : false" />
        </div>
      </div>

      <div class="col-md-8 col-12 card-modificar">
        <template v-for="(informacionReserva, index) in grupo.reservas" :key="informacionReserva.id">
          <CardModificarReserva :idx-reserva="index" :informacion-grupo="grupo" />
        </template>
      </div>
      <div class="col-4 resumen-card">
        <div class="sticky-card">
          <CardInfoExperiencia />
          <CardInfoReserva />
        </div>
      </div>
    </div>

    <div class="text-center py-3 d-flex flex-wrap justify-content-center gap-2">
      <MyGocuButton secondary :label="$t('botones.cancelar')" @click="moveToMisReservas" />
      <MyGocuButton primary :label="$t('botones.modificar')" @click="modificarReserva" />
    </div>
  </div>

  <!--  MODAL RESUMEN RESERVA -->
  <div v-if="isModalOpen" class="custom-bottom-modal d-flex align-items-end" @click="closeModal">
    <div class="custom-modal-content" @click.stop>
      <button type="button" class="btn-close-modal" @click="closeModal">
        <i class="fa-solid fa-times"></i>
      </button>
      <div class="modal-body-custom pt-10 pl-10 pr-10">
        <template v-if="storeHabitacion.getReservas.length > 0">
          <CardInfoExperiencia />
          <CardInfoReserva />
        </template>
      </div>
    </div>
  </div>

  <!-- BOTTOM BAR -->
  <div v-if="!isInscripcion" class="bottom-fixed-reservation d-flex justify-content-end align-items-end d-md-none">
    <div class="d-flex align-items-center h-100">
      <div class="p medium text-primary mr-20 d-flex align-items-center h-100">
        {{ $t('subtitulo.importeTotal') }}
      </div>
    </div>
    <div class="bottom-fixed-reservation__summary">
      <MyGocuButton primary @click="toggleModal">
        <div class="reservation-info d-flex align-items-center w-100">
          <div class="reservation-total d-flex align-items-center">
            {{ formatPrice(calculaPrecioTotalReservas(storeHabitacion.getResumenReservas)) }}
            {{ agenciaStore.getCurrency }}
            <CustomIcon :icon="isModalOpen ? arrowDownIcon : arrowUpIcon" size="16px" class="pointer text-primary" />
          </div>
        </div>
      </MyGocuButton>
    </div>
  </div>

  <!-- BOTTOM BAR WHEN MODAL IS OPEN -->
  <div v-if="isModalOpen" class="bottom-fixed-modal-buttons">
    <div class="modal-buttons-container p medium px-15 py-10 d-flex flex-column">
      <div class="modal-buttons-container__continuar">
        <MyGocuButton primary :label="$t('botones.modificar')" @click="modificarReserva">
          <template #suffix-icon>
            <span v-if="!isInscripcion" class="continuar-price bold ms-2">
              {{ formatPrice(calculaPrecioTotalReservas(storeHabitacion.getResumenReservas))
              }}{{ agenciaStore.getCurrency }}
            </span>
          </template>
        </MyGocuButton>
      </div>
      <div class="modal-buttons-container__volver">
        <MyGocuButton secondary :label="$t('botones.volver')" @click="closeModal">
          <template #suffix-icon>
            <i class="fa-solid fa-arrow-right small ms-2" />
          </template>
        </MyGocuButton>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useRoute, useRouter } from 'vue-router';
  import { proximasExperiencias } from '@/store_pinia/proximasExperiencias';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { ref, computed, onBeforeMount } from 'vue';
  import CardModificarReserva from './components/CardModificarReserva.vue';
  import ReservasApiService from '@/services/api/ReservasApiService';
  import { alertAutoCloseWarningWithoutCallback } from '@/services/utils/AlertUtils';
  import CardOccupancy from '@/modules/viajesGrupos/components/CardOccupancy.vue';
  import { occupantsNotManagedReservations, occupantsManagedReservations } from '@/services/utils/GrupoUtils';
  import CardInfoExperiencia from '@/components/card/Reserva/CardInfoExperiencia.vue';
  import CardInfoReserva from '@/components/card/Reserva/CardInfoReserva.vue';
  import { UsuarioProximaReservasConfirmacion, UsuarioProximasReservasDetalle } from '@/router/RouterNames';
  import { toRawDeep } from '@/helpers/reactivityUtils';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { calculaPrecioTotalReservas } from '@/helpers/viajesGrupos';
  import { formatPrice } from '@/helpers/numberUtils';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import CustomIcon from '@/components/CustomIcon.vue';
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import arrowDownIcon from '@/assets/icons/arrow_down.svg';
  import arrowUpIcon from '@/assets/icons/arrow_up.svg';
  import { ESTADOS_INVITACION_GRUPO, TIPOS_PAGO } from '@/constants/viajeConstants';
  import { viajesGrupos } from '@/store_pinia/viajesGrupo';

  const route = useRoute();
  const router = useRouter();
  const loadingStore = useLoadingStore();
  const storeHabitacion = informacionHabitacion();
  const agenciaStore = agenciaStoreModule();
  const grupoId = route.params.grupoId;
  const storeProxExp = proximasExperiencias();
  const grupo = ref(null);
  const initializing = ref(true);
  const isModalOpen = ref(false);
  const viajesGruposStore = viajesGrupos();

  const viaje = computed(() => viajesGruposStore.getViajeSeleccionado);
  const hasAlojamiento = computed(() => grupo.value && grupo.value.habitacion);
  const isInscripcion = computed(
    () =>
      viaje.value?.tipoPago === TIPOS_PAGO.SIN_PAGO ||
      viaje.value?.invitacionGrupo?.estado === ESTADOS_INVITACION_GRUPO.ACEPTADA
  );
  const ocupantesNoGestionados = computed(() => {
    if (grupo.value) {
      return occupantsNotManagedReservations(grupo.value);
    } else {
      return [];
    }
  });

  const ocupantesGestionados = computed(() => {
    if (grupo.value) {
      return occupantsManagedReservations(grupo.value);
    } else {
      return [];
    }
  });

  const occupants = computed(() => [...ocupantesNoGestionados.value, ...ocupantesGestionados.value]);

  function toggleModal() {
    isModalOpen.value = !isModalOpen.value;
  }

  function closeModal() {
    isModalOpen.value = false;
  }

  function moveToMisReservas() {
    router.push({
      name: UsuarioProximasReservasDetalle,
      params: { grupoId: grupoId },
    });
  }

  async function modificarReserva() {
    try {
      loadingStore.show();

      let reservaModificarBody = {
        reservas: [],
      };

      if (storeHabitacion.getReservas.length === 0) {
        alertAutoCloseWarningWithoutCallback(3000, 'No hay reservas seleccionadas para modificar');
        return;
      }
      storeHabitacion.getReservas.forEach(reserva => {
        let body = {
          id: reserva.id,
          serviciosWithCantidades: Object.values(reserva.serviciosWithCantidad).map(swc => {
            return { id: swc.servicio.id, cantidad: swc.cantidad };
          }),
        };
        reservaModificarBody.reservas.push(body);
      });

      await ReservasApiService.doModificarServiciosReservasGrupo(grupoId, reservaModificarBody);
      router.push({
        name: UsuarioProximaReservasConfirmacion,
        params: {
          grupoId: grupoId,
        },
      });
    } catch (error) {
      console.error(error);
      alertAutoCloseWarningWithoutCallback(3000, 'La reserva ya no permite modificaciones');
    } finally {
      loadingStore.hide();
    }
  }

  async function init() {
    try {
      loadingStore.show();
      await storeProxExp.setGrupoSeleccionado(grupoId);
      grupo.value = storeProxExp.getGrupoSeleccionado;
      await storeHabitacion.loadInformacionViaje(
        grupo.value.viaje.id,
        grupo.value.viaje.codigo ?? null,
        true,
        grupo.value.viaje.codigoPrevisualizacion ?? null
      );

      storeHabitacion.clearReservas();
      const grupoRaw = toRawDeep(grupo.value);
      storeHabitacion.setInformacionAlojamientoFromRGrupoDTO(grupoRaw);
      grupoRaw.reservas.map(reserva => {
        // Need to normalise the reservaDTO from reservaAPI to the viajeGrupoDTO one
        // todo -> Ask back to unify both reservaDTOs
        reserva.usuario = {
          nombre: reserva.nombre,
          apellidos: reserva.apellidos,
          fechaNacimiento: reserva.fechaNacimiento,
          // todo -> Normalise to use apellidos
          apellido: reserva.apellidos,
        };
        storeHabitacion.addReserva(reserva);
      });
    } catch (error) {
      console.error(error);
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(() => init());
</script>

<style lang="scss" scoped>
  .container-resumen {
    padding-top: 13rem;

    @media screen and (max-width: 768px) {
      padding-top: 6rem;
    }
  }

  .volver-atras {
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
    font-weight: 700;
    cursor: pointer;
  }

  .resumen-card {
    display: none;
  }

  .card-modificar {
    width: 100%;
  }

  @media only screen and (min-width: 990px) {
    .resumen-card {
      display: block;
    }

    .card-modificar {
      width: 65%;
    }
    .contenedor {
      padding: 0px 48px !important;
    }
  }

  .contenedor {
    padding: 0px 20px;
  }

  .sticky-card {
    position: sticky;
    top: 10rem;
    z-index: 10;
  }

  .bottom-fixed-reservation {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: 60px;
    padding: 10px 15px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
    justify-content: right;
    align-items: end;
    background-color: white;
    border-top: 1px solid rgba(var(--bs-primary-rgb), 0.2);

    /* Soporte iOS Safari */
    @supports (-webkit-touch-callout: none) {
      bottom: env(safe-area-inset-bottom, 0);
      padding-bottom: 10px;
    }
  }

  .bottom-fixed-reservation__summary {
    flex: 0 0 auto;
    max-width: 100%;

    :deep(.mg-btn-root) {
      display: inline-block;
      max-width: 100%;
    }

    :deep(.mg-btn-face) {
      justify-content: space-between;
    }
  }

  .reservation-info {
    text-align: left;
    flex: 1;
  }

  .reservation-total {
    gap: 8px;
  }

  .custom-bottom-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1006;
    background-color: rgba(var(--bs-primary-rgb), 0.5);
    align-items: flex-end;
  }

  .custom-modal-content {
    width: 100%;
    background-color: var(--bs-white);
    border-radius: 20px 20px 0 0;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0px -4px 20px rgba(var(--bs-primary-rgb), 0.15);
  }

  .modal-body-custom {
    padding-bottom: 120px;
  }

  .btn-close-modal {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 32px;
    height: 32px;
    background-color: rgba(var(--bs-secondary-rgb), 0.5);
    border: none;
    border-radius: 50%;
    color: var(--bs-primary);
    font-size: 16px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
  }

  .bottom-fixed-modal-buttons {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1007;
    background-color: white;
    border-top: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    padding-bottom: env(safe-area-inset-bottom, 0);

    /* Soporte iOS Safari */
    @supports (-webkit-touch-callout: none) {
      bottom: env(safe-area-inset-bottom, 0);
      padding-bottom: 0;
    }

    @media (min-width: 768px) {
      display: none;
    }
  }

  .modal-buttons-container {
    flex-direction: column;
    gap: 10px;
  }

  .modal-buttons-container__continuar,
  .modal-buttons-container__volver {
    :deep(.mg-btn-root) {
      width: 100%;
    }

    :deep(.mg-btn) {
      width: 100%;
    }
  }

  .modal-buttons-container__continuar {
    :deep(.mg-btn-face) {
      justify-content: space-between;
      width: 100%;
    }
  }

  .modal-buttons-container__volver {
    :deep(.mg-btn-face) {
      justify-content: space-between;
      width: 100%;
    }
  }

  .continuar-price {
    color: var(--bs-primary);
  }
</style>
